var _mask, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChevLeft(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 10,
    viewBox: "0 0 9 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-outside-1_21_1118",
    maskUnits: "userSpaceOnUse",
    x: -2,
    y: -1,
    width: 13,
    height: 12,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: -2,
    y: -1,
    width: 13,
    height: 12
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.78 9.34L0.32 4.82L4.78 0.319999H8.02L3.52 4.82L8.02 9.34H4.78Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.78 9.34L0.32 4.82L4.78 0.319999H8.02L3.52 4.82L8.02 9.34H4.78Z",
    fill: "#171718"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.78 9.34L4.06818 10.0424L4.36187 10.34H4.78V9.34ZM0.32 4.82L-0.390256 4.11606L-1.0864 4.81844L-0.391815 5.52237L0.32 4.82ZM4.78 0.319999V-0.680001H4.36317L4.06974 -0.383944L4.78 0.319999ZM8.02 0.319999L8.72711 1.02711L10.4342 -0.680001H8.02V0.319999ZM3.52 4.82L2.81289 4.11289L2.10735 4.81843L2.81133 5.52554L3.52 4.82ZM8.02 9.34V10.34H10.4267L8.72867 8.63446L8.02 9.34ZM5.49182 8.63763L1.03182 4.11763L-0.391815 5.52237L4.06818 10.0424L5.49182 8.63763ZM1.03026 5.52394L5.49026 1.02394L4.06974 -0.383944L-0.390256 4.11606L1.03026 5.52394ZM4.78 1.32H8.02V-0.680001H4.78V1.32ZM7.31289 -0.387108L2.81289 4.11289L4.22711 5.52711L8.72711 1.02711L7.31289 -0.387108ZM2.81133 5.52554L7.31133 10.0455L8.72867 8.63446L4.22867 4.11446L2.81133 5.52554ZM8.02 8.34H4.78V10.34H8.02V8.34Z",
    fill: "#ACD1D1",
    mask: "url(#path-1-outside-1_21_1118)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevLeft);
export default __webpack_public_path__ + "static/media/chevLeft.32b2276d76d64730c23d035a14f9ad1e.svg";
export { ForwardRef as ReactComponent };